/**
 * Side-effect-only module: installs the global auth interceptor the moment this file is imported.
 *
 * WHY: `installAuthInterceptor()` was previously called inside `AuthProvider`'s `useEffect`, which
 * runs AFTER the first render. On a fresh page load the browser can fire API calls (e.g. TanStack
 * Router loaders, SignalR negotiate, last-seen keep-alive) before that effect runs, so those
 * requests never get the 401→refresh retry and fail with the expired token. Importing this module
 * in `__root.tsx` (or any other entry point) moves the interception to module-evaluation time,
 * which precedes the first render and therefore the first fetch.
 *
 * The function is idempotent (it checks `installed`), so the call from `use-auth.tsx`'s effect is
 * now a harmless no-op rather than the sole install path.
 */

import { installAuthInterceptor } from "./install-auth-interceptor";

if (typeof window !== "undefined") {
  installAuthInterceptor();
}
